import { render, staticRenderFns } from "./contextmenu.vue?vue&type=template&id=4dea92c8&scoped=true&"
import script from "./contextmenu.vue?vue&type=script&lang=js&"
export * from "./contextmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea92c8",
  null
  
)

export default component.exports